import {Component, Host, h,  Listen, Event, EventEmitter, Prop} from '@stencil/core';

import { HamburgerEvent } from './HamburgerEvent';
import {$$$} from "../../../utils/utils";

@Component({
  tag: 'lilu-hamburger',
  styleUrl: 'lilu-hamburger.scss',
  shadow: true,
})
export class LiluHamburger {
  @Prop() isHamburgerClicked = false;

  @Event({
    eventName: 'hamburgerEventEmitter',
    composed: true,
    cancelable: true,
    bubbles: true,
  }) hamburgerEventEmitter: EventEmitter<HamburgerEvent>;

  componentDidLoad() {
    document.addEventListener('keyup', e => {
      if (this.isHamburgerClicked
          && e.key === 'Escape'
          && typeof($$$('.search__autocomplete.show')[0]) === 'undefined') {
        this.setIsHamburgerClicked(false);
      }
    });
  }

  @Listen('click')
  hamburgerHandler() {
    this.setIsHamburgerClicked(!this.isHamburgerClicked);
  }

  setIsHamburgerClicked(value: boolean) {
    this.isHamburgerClicked = value;
    this.hamburgerEventEmitter.emit({ isOpen: this.isHamburgerClicked });
  }

  render() {
    return (
      <Host>
        <div class={`hamburger ${this.isHamburgerClicked ? 'open' : ''}`}>
          <span></span>
        </div>
      </Host>
    );
  }
}
